<app-shared-dialog
  [title]="'quotations_and_orders.segregation.linked_orders_title' | translate"
  [options]="dialogOptions"
  (cancel)="close()">

  <div class="lom-list">
    <a *ngFor="let split of splits; trackBy: trackById"
       class="lom-row"
       [routerLink]="['/quotations', split.id]"
       queryParamsHandling="merge"
       (click)="close()">
      <span class="lom-row__left">
        <span class="lom-row__name">{{ split.name }}</span>
        <span class="lom-row__destination" *ngIf="split.destination_name">{{ split.destination_name }}</span>
      </span>
      <span class="lom-row__right">
        <span class="lom-row__erp" *ngIf="split.external_id">{{ split.external_id }}</span>
        <span class="lom-row__status" *ngIf="split.status" [ngStyle]="statusStyles(split.status)">
          {{ 'quotations_and_orders.QuotationStatus.' + split.status | translate }}
        </span>
        <ui-icon name="ChevronRight" size="small" class="lom-row__open"></ui-icon>
      </span>
    </a>
  </div>

  <div class="lom-footer">
    <span class="lom-footer__hint">{{ 'quotations_and_orders.segregation.linked_orders_hint' | translate }}</span>
  </div>

</app-shared-dialog>
